//kiran
import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { Workbook } from 'exceljs';


const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';



@Injectable({
  providedIn: 'root'
})
export class ExcelServiceService {

    public exportToExcel(headersArray: any[], json: any[], excelFileName: string, sheetName: string) {
        const header = headersArray;
        const data = json;
    
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(sheetName);
        
        /*Add Header Row*/
        const headerRow = worksheet.addRow(header);
    
        //Cell style: Fill and Border
        headerRow.eachCell((cell, index) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'FFFFFFFF'},
            bgColor: {argb: 'FFFFFFFF'}
          };
    
          cell.border = {top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}};
          cell.font = {size: 12, bold: true};
          cell.alignment = {vertical: 'middle', horizontal:'center'};
    
          worksheet.getColumn(index).width = header[index - 1].length < 35 ? 35 : header[index - 1].length;
        });
    
        //Get all columns from JSON
        let columnsArray: any[];
        for(const key in json) {
          if(json.hasOwnProperty(key)) {
            columnsArray = Object.keys(json[key]);
          }
        }
    
        //Add Data and Conditional Formating
        data.forEach((element: any)=>{
          const eachRow  = [];
          columnsArray.forEach((column)=>{
            eachRow.push(element[column]);
          });
    
          if(element.isDeleted === 'Y') {
            const deletedRow = worksheet.addRow(eachRow);
            deletedRow.eachCell((cell)=>{
              cell.font = {name: 'Calibri', family: 4, size: 12, bold: false, strike: true};
            });
          }else{
            worksheet.addRow(eachRow);
          }
        });
    
        /*Save Excel File*/
        workbook.xlsx.writeBuffer().then((data: ArrayBuffer)=>{
          const blob = new Blob([data], {type: EXCEL_TYPE});
          FileSaver.saveAs(blob, excelFileName + EXCEL_EXTENSION);
        });
      }
}
